import { CommonModule } from '@angular/common'
import { Component, Inject } from '@angular/core'
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar'

@Component({
    selector: 'custom-snackbar',
    template: `
    <div style="color: white; border-radius: 4px;">
      {{ data.text }}
    </div>
  `,
    styles: [],
    imports: [CommonModule]
})
export class CustomSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { text: string }) {}
}
